import { OrganizationJobPosition } from '@/shared/api/protocol-ts/model/dto_organization_job_position_pb';

export const isValidJobPosition = (
  position: OrganizationJobPosition,
): boolean => {
  return (
    position !== OrganizationJobPosition.OrganizationJobPositionOther &&
    position !== OrganizationJobPosition.OrganizationJobPositionInvalidValue
  );
};
